import styled from 'styled-components';
import { BASE_SPINDLE_BE_URL } from 'utils/constants';
import { USER_LOCAL_STORAGE_KEY } from 'contexts/auth';

const StyledExplorer = styled.div`
  width: 100%;
  height: auto;
  position: relative;
  padding: 40px;
`;

const StyledIFrame = styled.iframe`
  border-radius: 4px;
  border: none;
  outline: none;
`;

const Explorer = () => {
  const user = JSON.parse(localStorage.getItem(USER_LOCAL_STORAGE_KEY));
  const accountId = user?.accountId;
  return (
    <StyledExplorer data-testid="explorer-dashboard-view">
      <StyledIFrame
        src={`${BASE_SPINDLE_BE_URL}/graphiql?id=${accountId}`}
        width="100%"
        height="100%"
      ></StyledIFrame>
    </StyledExplorer>
  );
};

export default Explorer;
